import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0895eb4a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserInfoBox: require('/drone/src/components/UserInfoBox/index.vue').default,OrderBoxSell: require('/drone/src/components/OrderBox/OrderBoxSell.vue').default})
